import { List, fromJS } from 'immutable';
import { ROUTING_RULE_TYPES } from '../constants/RoutingTypes';
import RoutingRuleBase from './RoutingRuleBase';
import { ensureIsList } from '../../shared/utils/immutable';
class TeamsOnlyRoutingRules extends RoutingRuleBase({
  '@type': ROUTING_RULE_TYPES.TEAMS_ONLY,
  teamIds: List()
}, 'TeamsOnlyRoutingRules') {
  constructor(options) {
    super(fromJS(options || {}));
    return this.update('teamIds', teamIds => ensureIsList(teamIds));
  }
}
export const buildTeamsOnlyRoutingRules = options => new TeamsOnlyRoutingRules(options);
export default TeamsOnlyRoutingRules;